import { Document } from 'data-layer-cr/dist/models';
import { isBefore } from 'date-fns';

const REF_DATE = new Date(process.env.REACT_APP_KYC_DATE as string);

export const canDownloadKYC = (creationDate: string): boolean => {
  const quotationDate = new Date(creationDate);
  return !isBefore(quotationDate, REF_DATE);
};

export const getStartDocumentList = (creationDate: string): string[] => {
  const quotationDate = new Date(creationDate);
  return isBefore(quotationDate, REF_DATE) ? [] : ['policy'];
};

export const getStartDocument = (creationDate: string): string => {
  const quotationDate = new Date(creationDate);
  return isBefore(quotationDate, REF_DATE) ? 'policy' : 'kyc';
};

export function hasIdentityDocument(
  documents: Document[] | undefined,
): boolean {
  if (!documents) {
    return false;
  }
  return documents.some(({ name }) => name.includes('cedula'));
}

export function hasOptionalIdentityDocument(
  documents: Document[] | undefined,
): boolean {
  if (!documents) {
    return false;
  }
  return documents.some(({ name }) => name.includes('cedula-optional'));
}
